import { PATIENT_DOCUMENTS } from "core/consts";
import { TransitionalCare } from "core/types";
import { DownloadSectionWrapper } from "dsl/ecosystems/PatientForms/components";
import {
  DOWNLOADED_PDF_NAME,
  useCreateTransitionalCarePdf,
} from "dsl/ecosystems/PatientForms/useCreateTransitionalCarePdf";
import { useTranslations } from "translations";
import { useDocumentHandling } from "../../useDocumentHandling";

export const TransitionalCareFormDownload = ({
  careseekerName,
  externalId,
  transitionalCare,
  userId,
}: {
  careseekerName: string;
  externalId: string;
  transitionalCare: Readonly<TransitionalCare> | undefined;
  userId: string;
}) => {
  const translations = useTranslations();
  const createTransitionalCarePdf = useCreateTransitionalCarePdf();
  const { handleOpenPdf, handleSendToHis, progressOpenPdf, progressSendToHis } =
    useDocumentHandling({
      careseekerName,
      createPDFDocument: createTransitionalCarePdf,
      externalId,
      userId,
    });

  if (!transitionalCare) return null;

  return (
    <DownloadSectionWrapper
      body={
        translations.patientForms.transitionalCareForm.downloadSection.bodyText
      }
      lastUpdated={transitionalCare.updated_at!}
      pdfName={DOWNLOADED_PDF_NAME}
      progressOpenPdf={progressOpenPdf}
      progressSendToHis={progressSendToHis}
      title={
        translations.patientForms.transitionalCareForm.downloadSection.title
      }
      onClickPrint={() => handleOpenPdf({ transitionalCare })}
      onClickSendToHis={() =>
        handleSendToHis({
          documentType: PATIENT_DOCUMENTS.TRANSITIONAL_CARE,
          transitionalCare,
        })
      }
    />
  );
};
